import React from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { ModalPopUpTable } from './ModalPopUpTable';
import $ from 'jquery';

function ExamFormInformationModal(props) {
    var modalTitle = "Information on Exam Form File Compliant";
    var validate = false;
    const handleClose = (e) => {
        props.hideInformationModal();
    }
    const information = "Accepted upload formats for the exam form include image formats (.jpg, .jpeg, .png, .gif) and PDF format. The upload will not proceed if a >5 MB exam form file is selected.";

    return (

        <div className="ExamFormInfoDiv" style={{ display: props.stateProps.showExamFormInformationModal }}>
            <div role="dialog" aria-modal="true" class="fade asd modal show" tabindex="-1">
                <div class="modal-dialog"><div class="modal-content">
                    <div class="modal-header">
                        <div class="modal-title h5">Information On Exam Form File Compliant Requirements </div>
                        <button type="button" class="close" onClick={(e) => { handleClose() }}><span aria-hidden="true">X</span><span class="sr-only">Close</span></button>
                    </div>
                    <div class="modal-body">{information}</div>
                </div></div></div>
        </div>
    );
}

export default ExamFormInformationModal